export default __webpack_public_path__ + "static/media/lubaantunGrid18.5e733ecd.webp";